<div mat-dialog-content>
    {{text}}
</div>

<div mat-dialog-actions align="end">
    <button type="button" (click)="buttonAction()" class="btn btn-custom" cdkFocusInitial>
      {{buttonName}}
  </button>
</div>